/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../Fixes';
import Builder from '../../../../../../Builder';
import '../../message/launch_darkly_project';
import './context';
import '../../message/status';
import './flag_groups';
import '../../message/context';
import './square_tokens';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "feature": {
        "nested": {
          "relay": {
            "nested": {
              "flags": {
                "nested": {
                  "v2": {
                    "nested": {
                      "message": {
                        "nested": {
                          "GetDeviceFlagsV2Request": {
                            "fields": {
                              "project": {
                                "type": ".squareup.feature.relay.flags.message.LaunchDarklyProject",
                                "id": 1,
                                "rule": "optional"
                              },
                              "deviceContext": {
                                "type": ".squareup.feature.relay.flags.v2.message.DeviceContextFlags",
                                "id": 2,
                                "rule": "optional"
                              },
                              "includeEvaluationMetadata": {
                                "type": "bool",
                                "id": 4,
                                "rule": "optional"
                              },
                              "sendFlagEvaluationMetricsToVendor": {
                                "type": "bool",
                                "id": 5,
                                "rule": "optional",
                                "options": {
                                  "default": true
                                }
                              }
                            }
                          },
                          "GetDeviceFlagsV2Response": {
                            "fields": {
                              "status": {
                                "type": ".squareup.feature.relay.flags.message.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "deviceFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.DeviceFlagsResponse",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "DeviceFlagsResponse": {
                            "fields": {
                              "flagGroups": {
                                "type": ".squareup.feature.relay.flags.v2.message.FlagGroupsResponse",
                                "id": 2,
                                "rule": "optional"
                              },
                              "squareMobileDevice": {
                                "type": ".squareup.feature.relay.flags.message.SquareMobileDevice",
                                "id": 1
                              },
                              "squareBrowser": {
                                "type": ".squareup.feature.relay.flags.message.SquareBrowser",
                                "id": 3
                              },
                              "browser": {
                                "type": ".squareup.feature.relay.flags.message.Browser",
                                "id": 4
                              }
                            },
                            "nested": {
                              "context": {
                                "oneof": [
                                  "squareMobileDevice",
                                  "squareBrowser",
                                  "browser"
                                ]
                              }
                            }
                          },
                          "GetAllFlagsV2Request": {
                            "fields": {
                              "project": {
                                "type": ".squareup.feature.relay.flags.message.LaunchDarklyProject",
                                "id": 1,
                                "rule": "optional"
                              },
                              "contextFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.ContextFlags",
                                "id": 2,
                                "rule": "optional"
                              },
                              "includeEvaluationMetadata": {
                                "type": "bool",
                                "id": 4,
                                "rule": "optional"
                              },
                              "sendFlagEvaluationMetricsToVendor": {
                                "type": "bool",
                                "id": 5,
                                "rule": "optional",
                                "options": {
                                  "default": true
                                }
                              }
                            }
                          },
                          "GetAllFlagsV2Response": {
                            "fields": {
                              "status": {
                                "type": ".squareup.feature.relay.flags.message.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "deviceFlagsResponse": {
                                "type": ".squareup.feature.relay.flags.v2.message.DeviceFlagsResponse",
                                "id": 2,
                                "rule": "optional"
                              },
                              "authorizedFlagsResponse": {
                                "type": ".squareup.feature.relay.flags.v2.message.AuthorizedFlagsResponse",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          },
                          "AuthorizedFlagsResponse": {
                            "fields": {
                              "userContexts": {
                                "type": ".squareup.feature.relay.flags.message.UserContext",
                                "id": 1,
                                "rule": "repeated"
                              },
                              "flagGroups": {
                                "type": ".squareup.feature.relay.flags.v2.message.FlagGroupsResponse",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "GetAllFlagsUsingTokensV2Request": {
                            "fields": {
                              "project": {
                                "type": ".squareup.feature.relay.flags.message.LaunchDarklyProject",
                                "id": 1,
                                "rule": "optional"
                              },
                              "deviceFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.DeviceContextFlags",
                                "id": 2,
                                "rule": "optional"
                              },
                              "squareTokensGroup": {
                                "type": ".squareup.feature.relay.flags.v2.message.SquareTokensGroup",
                                "id": 3
                              }
                            },
                            "nested": {
                              "authorized_flags": {
                                "oneof": [
                                  "squareTokensGroup"
                                ]
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.GetDeviceFlagsV2Request && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.GetDeviceFlagsV2Response && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.DeviceFlagsResponse && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.GetAllFlagsV2Request && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.GetAllFlagsV2Response && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.AuthorizedFlagsResponse && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.GetAllFlagsUsingTokensV2Request) {
	$root.addJSON(jsonData);
}

/**
 * Device Flags
 *
 * SOURCE GetDeviceFlagsV2Request @ squareup/feature/relay/flags/v2/message/get_flags_v2.proto at 18:1
 */
export const GetDeviceFlagsV2Request = $root.lookupType('squareup.feature.relay.flags.v2.message.GetDeviceFlagsV2Request');
fixType(GetDeviceFlagsV2Request, {
  project: { required: true },
});
Builder.createAndAttachToType(GetDeviceFlagsV2Request);
/**
 * SOURCE GetDeviceFlagsV2Response @ squareup/feature/relay/flags/v2/message/get_flags_v2.proto at 38:1
 */
export const GetDeviceFlagsV2Response = $root.lookupType('squareup.feature.relay.flags.v2.message.GetDeviceFlagsV2Response');
fixType(GetDeviceFlagsV2Response);
Builder.createAndAttachToType(GetDeviceFlagsV2Response);
/**
 * SOURCE DeviceFlagsResponse @ squareup/feature/relay/flags/v2/message/get_flags_v2.proto at 46:1
 */
export const DeviceFlagsResponse = $root.lookupType('squareup.feature.relay.flags.v2.message.DeviceFlagsResponse');
fixType(DeviceFlagsResponse);
Builder.createAndAttachToType(DeviceFlagsResponse);
/**
 * All Flags
 *
 * SOURCE GetAllFlagsV2Request @ squareup/feature/relay/flags/v2/message/get_flags_v2.proto at 60:1
 */
export const GetAllFlagsV2Request = $root.lookupType('squareup.feature.relay.flags.v2.message.GetAllFlagsV2Request');
fixType(GetAllFlagsV2Request, {
  project: { required: true },
  contextFlags: { required: true },
});
Builder.createAndAttachToType(GetAllFlagsV2Request);
/**
 * SOURCE GetAllFlagsV2Response @ squareup/feature/relay/flags/v2/message/get_flags_v2.proto at 80:1
 */
export const GetAllFlagsV2Response = $root.lookupType('squareup.feature.relay.flags.v2.message.GetAllFlagsV2Response');
fixType(GetAllFlagsV2Response);
Builder.createAndAttachToType(GetAllFlagsV2Response);
/**
 * SOURCE AuthorizedFlagsResponse @ squareup/feature/relay/flags/v2/message/get_flags_v2.proto at 88:1
 */
export const AuthorizedFlagsResponse = $root.lookupType('squareup.feature.relay.flags.v2.message.AuthorizedFlagsResponse');
fixType(AuthorizedFlagsResponse);
Builder.createAndAttachToType(AuthorizedFlagsResponse);
/**
 * All Flags Using Tokens
 *
 * SOURCE GetAllFlagsUsingTokensV2Request @ squareup/feature/relay/flags/v2/message/get_flags_v2.proto at 98:1
 */
export const GetAllFlagsUsingTokensV2Request = $root.lookupType('squareup.feature.relay.flags.v2.message.GetAllFlagsUsingTokensV2Request');
fixType(GetAllFlagsUsingTokensV2Request, {
  project: { required: true },
});
Builder.createAndAttachToType(GetAllFlagsUsingTokensV2Request);
